import newOrderStore from "@/store/modules/newOrder";

const COUPON_ID = {
  development: "52a0c532-85d4-46f2-bcf7-859cde390a15",
  staging: "7e6a77da-df5f-4c8a-9931-721554fcaa81",
  production: "ab3ea51f-1446-459c-a3b1-3a8a207a8aa5"
};

const PROFESSIONALS_WHO_ACCEPT_DISCOUNT = {
  development: [
    {
      id: "30423b46-e622-4cf9-8474-236a1b853c26", //Gustavo
      maxApplicableOrders: 11
    }
  ],
  staging: [
    {
      id: "fdcae303-dac0-4622-9785-0baf384a791d", //Gustavo
      maxApplicableOrders: 10
    },
    {
      id: "4f04c399-c353-4968-9502-6bda0e1046b8", //Joao
      maxApplicableOrders: 5
    },
    {
      id: "017781fb-4968-487c-bdd5-814a0d326d00", //Janine
      maxApplicableOrders: 1
    }
  ],
  production: [
    { id: "c3d53718-b692-45cd-a1c7-48dc1a6fbd83", maxApplicableOrders: 3 },
    { id: "5874e82b-5777-4d70-9011-db9537419640", maxApplicableOrders: 3 },
    { id: "c3d53718-b692-45cd-a1c7-48dc1a6fbd83", maxApplicableOrders: 5 },
    { id: "196f594c-ec38-4e83-a1e8-e4960244e76d", maxApplicableOrders: 15 },
    { id: "96a8c0ef-2929-4c29-ac50-b81314ea1557", maxApplicableOrders: 3 },
    { id: "f4441579-f582-40ba-9bc9-1d692625c14f", maxApplicableOrders: 5 },
    { id: "bc2a8c46-5528-4c73-b332-f7314e0c292b", maxApplicableOrders: 3 },
    { id: "7bfe543d-fb44-423c-a56a-e1b9d4f881fc", maxApplicableOrders: 15 },
    { id: "ec9b7add-8b67-45c4-b976-4aeb4d704298", maxApplicableOrders: 3 },
    { id: "ad607e2a-fb77-41b1-a831-6fdf9faf558a", maxApplicableOrders: 10 },
    { id: "6f9326eb-9846-4a99-9b80-788bb8eabe4e", maxApplicableOrders: 3 },
    { id: "210d9055-c587-4c21-9ed1-0ffe636f6299", maxApplicableOrders: 3 },
    { id: "27a9a0c3-a23a-49a2-b461-158ca8947c11", maxApplicableOrders: 3 },
    { id: "e1af3f6a-a33a-4590-83ea-2a689f82cf0b", maxApplicableOrders: 5 },
    { id: "636c0d2f-e65d-4c61-94a3-db356b7e057c", maxApplicableOrders: 3 },
    { id: "5f5bcf93-831d-48c4-903d-b84a495f7209", maxApplicableOrders: 5 },
    { id: "87c1e16d-a3f0-4cf3-a2ea-3d038f39f09a", maxApplicableOrders: 3 },
    { id: "ac87f672-4b11-45f3-96b3-4b7a211e491c", maxApplicableOrders: 3 },
    { id: "a53b7417-13c9-43ac-8df1-0d5dec248c6c", maxApplicableOrders: 3 },
    { id: "7f0e0274-e00d-4e41-b7c9-b887664f820e", maxApplicableOrders: 3 },
    { id: "8b4ac32f-7c02-4cf2-aed5-ae81471a2cd6", maxApplicableOrders: 3 },
    { id: "1e28ff06-2c3a-42ce-8acc-b1e261d939dd", maxApplicableOrders: 10 },
    { id: "50008616-a018-41a5-bc17-41ef599cbd50", maxApplicableOrders: 7 },
    { id: "10952a05-5ea2-4553-909a-57c84c1a4a5c", maxApplicableOrders: 7 },
    { id: "8b7477d1-e48b-4a89-abdb-8feb846580b9", maxApplicableOrders: 3 },
    { id: "05ae9c97-24ca-4ac6-910e-fbfb197e5c72", maxApplicableOrders: 3 },
    { id: "161b81bd-9e22-48a0-b286-ceaa866acf1b", maxApplicableOrders: 5 },
    { id: "82a72b47-0687-4c51-a3c1-77f80cd33d72", maxApplicableOrders: 3 },
    { id: "6655b16e-0baf-4346-bfef-699c94ab1052", maxApplicableOrders: 3 },
    { id: "2621ec8f-6905-4d34-8d52-b3f4ce25a7eb", maxApplicableOrders: 10 },
    { id: "7d4109ea-1bcc-4cf8-b044-6405f64d4765", maxApplicableOrders: 7 },
    { id: "5d1da4d3-754b-4d23-8232-5a428941c9b1", maxApplicableOrders: 3 },
    { id: "72e6d594-a51c-4400-be61-9fcc3ed7b9f8", maxApplicableOrders: 5 },
    { id: "95702bd4-e041-4aed-85f3-a65b3ca8ba14", maxApplicableOrders: 3 },
    { id: "a0abfe18-1d80-4b38-aba0-22cc28175604", maxApplicableOrders: 3 },
    { id: "83c1e826-9ba8-4045-8eec-9142a66706df", maxApplicableOrders: 10 },
    { id: "a950c3e9-f123-40a4-b38f-a57fb3d411ee", maxApplicableOrders: 3 },
    { id: "e25963aa-a9a6-4bcd-9806-c07b73c6c7fa", maxApplicableOrders: 3 },
    { id: "85b6c637-1700-409f-a6cf-b1c964b27cf9", maxApplicableOrders: 3 },
    { id: "ec91c082-9161-4256-be17-1f3dc7388786", maxApplicableOrders: 15 },
    { id: "db6e8ae3-5805-44d9-a302-7bfda5d090d8", maxApplicableOrders: 3 },
    { id: "3c162ef7-b72c-4c0f-8037-7dc9e59cd484", maxApplicableOrders: 5 },
    { id: "4a49e349-f7d4-4479-b80b-a4cba4259970", maxApplicableOrders: 7 },
    { id: "82ffd228-db5e-43cf-b5a4-4c41fb7c39cc", maxApplicableOrders: 3 },
    { id: "f15885f8-f004-42e0-8f5a-3c1158afa060", maxApplicableOrders: 3 },
    { id: "8c020baa-124d-4818-9404-c0164b185e8e", maxApplicableOrders: 15 },
    { id: "35a4025d-c991-4ef0-8eff-30df0220735e", maxApplicableOrders: 7 },
    { id: "19cf852f-e319-4795-8171-bc259925efe3", maxApplicableOrders: 3 },
    { id: "5d1b87bd-6318-4867-93b8-0f15ed2dc074", maxApplicableOrders: 3 },
    { id: "be73f310-0052-4033-8360-9089582c065d", maxApplicableOrders: 3 },
    { id: "c445d63f-ead4-4365-866f-3b1818119540", maxApplicableOrders: 3 },
    { id: "97e70bc6-e17c-4d1c-8d2b-2476020faa07", maxApplicableOrders: 5 },
    { id: "bf903bde-c6ef-4b84-a813-76004afe79db", maxApplicableOrders: 3 },
    { id: "f6412e1a-f52a-4357-9dd8-c8b079f64335", maxApplicableOrders: 5 },
    { id: "dd16cc46-c045-4525-864d-597cbfbebc8f", maxApplicableOrders: 3 },
    { id: "068b3c61-5e89-4c7d-806c-9d5107f5636c", maxApplicableOrders: 3 },
    { id: "610c469c-445a-4025-ad24-02f5dad6726f", maxApplicableOrders: 5 },
    { id: "fe050b16-1a32-44aa-9fb2-9772b227aad5", maxApplicableOrders: 5 },
    { id: "87583b8e-ee5d-4e2d-b353-55559dda5af8", maxApplicableOrders: 5 },
    { id: "c77920dd-b4ee-4a72-82ca-ffe0f4e427dd", maxApplicableOrders: 5 },
    { id: "4a67b511-5c16-41c6-81e0-acfdb40382af", maxApplicableOrders: 3 },
    { id: "677a0ebe-cff2-4f82-9693-6d8de094aa7c", maxApplicableOrders: 15 },
    { id: "0a67cc53-8d91-431e-97ad-e0c8e623bd0f", maxApplicableOrders: 3 },
    { id: "0d7d9bbf-55d3-4335-8d4a-5849fa1aca84", maxApplicableOrders: 5 },
    { id: "723d034b-0f5d-435d-880d-cbd88321be6b", maxApplicableOrders: 3 },
    { id: "3fa00091-26f7-46c1-9f66-f30899e45ca3", maxApplicableOrders: 3 },
    { id: "e7865f89-f013-4608-943b-a4ce649e2186", maxApplicableOrders: 10 },
    { id: "f085883a-37fe-4901-9689-f4e2d6e0d8cf", maxApplicableOrders: 3 },
    { id: "207ab986-50c1-4946-a0f4-08ca4dcfb3c4", maxApplicableOrders: 15 },
    { id: "443f5f55-98c4-4dad-9520-db032bd42135", maxApplicableOrders: 3 },
    { id: "4efd924c-2adb-42c8-8dd7-e52ca7dc7a72", maxApplicableOrders: 15 },
    { id: "e9aed326-36f3-467e-a3a5-3160259c8fae", maxApplicableOrders: 3 },
    { id: "ee319315-60cc-49f9-94eb-2263c61e4491", maxApplicableOrders: 3 },
    { id: "650cc08e-a05d-42cc-9de3-e261b5e0531b", maxApplicableOrders: 3 },
    { id: "a0ace7a6-c787-4868-a141-68450c4c39b6", maxApplicableOrders: 5 },
    { id: "d4448380-dc5e-40ea-829a-d3fe68a558b5", maxApplicableOrders: 3 },
    { id: "458c4812-e822-49b5-8080-7475d0b15b77", maxApplicableOrders: 15 },
    { id: "63f6feb8-8647-4bc8-adf6-7881b8828371", maxApplicableOrders: 5 },
    { id: "ed8817ac-c797-432e-9231-2b14101bbda0", maxApplicableOrders: 5 },
    { id: "112d148b-d2a5-4b50-8b39-4392a6a31040", maxApplicableOrders: 3 },
    { id: "d8808767-4bab-464f-918a-0db78f64a47d", maxApplicableOrders: 7 },
    { id: "28d5015a-4124-4377-a02e-59d2d93b70bd", maxApplicableOrders: 3 },
    { id: "860effe5-f2c8-4080-96af-c066ca27bfdd", maxApplicableOrders: 5 },
    { id: "5c1761c4-75fd-4c9f-8e8b-4948b3c8f67c", maxApplicableOrders: 5 },
    { id: "e86b8d72-be37-4204-a386-5674d6d0038d", maxApplicableOrders: 5 },
    { id: "b6323598-81b5-440e-9579-b2ee25cba34d", maxApplicableOrders: 5 },
    { id: "a4062dfd-9562-4a66-bf82-8d4cd99fba04", maxApplicableOrders: 3 },
    { id: "12dbb1a1-69d2-4729-895b-d904e6ba60e6", maxApplicableOrders: 15 },
    { id: "772a7595-8a12-4971-b175-7ae90b429c8f", maxApplicableOrders: 8 },
    { id: "ea6ee887-3c07-4484-8dce-471ce0dedae3", maxApplicableOrders: 3 },
    { id: "45919235-6d12-42c9-9b68-d1659c6993cf", maxApplicableOrders: 3 },
    { id: "c62d5cc7-40c0-4c85-a893-c01cf6ceb035", maxApplicableOrders: 3 },
    { id: "66a9177a-b7e8-45ea-9915-aa292c142e0e", maxApplicableOrders: 15 },
    { id: "4bb24d26-e45f-4638-8d81-0fef9e8f962d", maxApplicableOrders: 15 },
    { id: "d5559b2d-bfa1-46b4-bf70-5b4be39eff1c", maxApplicableOrders: 15 },
    { id: "d07348e6-e210-43cd-ba6f-aab155afaa5d", maxApplicableOrders: 3 },
    { id: "f27a8c3d-b3b5-445b-babc-6d52e7d7a6ff", maxApplicableOrders: 3 },
    { id: "5dcc1a40-87f5-4e8f-ae8b-295f8498fc7c", maxApplicableOrders: 15 },
    { id: "0c2e9691-e61c-49b3-b80b-784173d1c904", maxApplicableOrders: 15 },
    { id: "87b69516-3f00-4b08-b1c2-57d627d2319b", maxApplicableOrders: 3 },
    { id: "7c1bb251-8c4c-4760-a9cc-523a6dec8e69", maxApplicableOrders: 3 },
    { id: "f8ecfdc3-17b3-4445-8076-c7a0f94da7e6", maxApplicableOrders: 3 },
    { id: "45919235-6d12-42c9-9b68-d1659c6993cf", maxApplicableOrders: 3 },
    { id: "5c8afc74-15a4-41ee-b885-2ff248251eda", maxApplicableOrders: 3 },
    { id: "5a576d6d-c2cf-4d9d-96fe-636cc2eb1bb0", maxApplicableOrders: 3 },
    { id: "c8b13281-cbdc-41bf-be78-62f5abfee85f", maxApplicableOrders: 3 },
    { id: "d0e48d1f-0ca5-45a1-99a0-1f725c50bd8c", maxApplicableOrders: 3 },
    { id: "f3d9ceee-c0fe-43fc-901f-ff2a31732042", maxApplicableOrders: 3 },
    { id: "30db2d4d-b149-4bb1-92e4-2963bf14dc80", maxApplicableOrders: 3 },
    { id: "613b4a79-81b9-4aa8-8437-2bfe5c0db9e2", maxApplicableOrders: 3 },
    { id: "6c562136-8eb2-4026-97b8-87c5ca1b8598", maxApplicableOrders: 3 },
    { id: "f1a48a40-c133-4f95-801f-6bca2a77229e", maxApplicableOrders: 5 },
    { id: "f41bcaa8-0497-4aea-8093-47711d0a8e27", maxApplicableOrders: 3 },
    { id: "e56366ac-6946-47a9-b1e6-294683875600", maxApplicableOrders: 10 },
    { id: "ba4de819-9685-476e-995d-1e95f2bc807a", maxApplicableOrders: 3 },
    { id: "1cedf089-7964-40e4-95db-2a1269474b33", maxApplicableOrders: 3 },
    { id: "761460d0-2ab6-486f-84fb-0210f4004899", maxApplicableOrders: 10 },
    { id: "8503a46c-849e-4faa-a17b-462e2789a5a2", maxApplicableOrders: 3 },
    { id: "ac3fa7af-5183-426e-9fc6-6b547ce466d6", maxApplicableOrders: 5 },
    { id: "880e2245-61ff-458d-8410-4686454e0925", maxApplicableOrders: 3 },
    { id: "18c05709-72cb-4462-9c54-ed0bb0700655", maxApplicableOrders: 3 },
    { id: "a76b728c-63b7-42aa-bb0a-2c8b1f015658", maxApplicableOrders: 3 },
    { id: "054cadd1-043f-425e-b7dc-725870973e5f", maxApplicableOrders: 3 },
    { id: "a3639c87-a60a-4373-99f0-1ffa8f59644f", maxApplicableOrders: 3 },
    { id: "4f22e7ba-baa4-4e40-85f3-75c5a1869a38", maxApplicableOrders: 3 },
    { id: "61b06241-2f17-47b2-ad8f-54d975698b94", maxApplicableOrders: 3 },
    { id: "88fbf883-fc6d-4d75-8a95-2b0ac5b708c0", maxApplicableOrders: 3 },
    { id: "a36f1f95-581e-4baa-901f-cf74cdd2a9ca", maxApplicableOrders: 3 },
    { id: "290f16df-3346-49a8-a2d4-af3875cc6d78", maxApplicableOrders: 3 },
    { id: "85fd4651-1ccf-4648-855b-871bd4509225", maxApplicableOrders: 10 },
    { id: "6b2f8416-ac1e-4f0c-b753-2f62e57c034c", maxApplicableOrders: 3 },
    { id: "252bb2a7-e56b-443a-8a7c-8fb652e4103c", maxApplicableOrders: 3 },
    { id: "a08b9a31-ff14-474d-9ea8-b732ee057412", maxApplicableOrders: 3 },
    { id: "50b1e4fb-105a-49c2-89c8-c4194aa6e1ee", maxApplicableOrders: 5 },
    { id: "6da45a2b-c805-48f5-a53a-d53ee7bac83a", maxApplicableOrders: 3 },
    { id: "0eb439ba-3066-4a7c-a983-ee2d6823b78b", maxApplicableOrders: 5 },
    { id: "55b85416-68a0-4d11-8286-f1bdea10e627", maxApplicableOrders: 3 },
    { id: "a44bc199-aaff-4ac6-abf6-c5fc09afe1c5", maxApplicableOrders: 5 },
    { id: "c445d63f-ead4-4365-866f-3b1818119540", maxApplicableOrders: 3 },
    { id: "c3e42a13-002d-4da2-8f96-cff46fb394bc", maxApplicableOrders: 5 },
    { id: "1920bbb6-d783-41bd-8d89-4af73c8951c7", maxApplicableOrders: 15 },
    { id: "4b258872-160c-410c-ab49-ab1c8062aedb", maxApplicableOrders: 15 },
    { id: "b33d3c98-602c-4f54-a9df-fdbb6bd083f5", maxApplicableOrders: 3 },
    { id: "de9818ad-e749-4efc-aada-0409ecf8d252", maxApplicableOrders: 3 },
    { id: "6285d30b-2b8d-47ba-b390-52fb2772bb80", maxApplicableOrders: 3 },
    { id: "8b117b1d-9d9a-4ae6-ae09-37c0c15c7e34", maxApplicableOrders: 3 },
    { id: "e5e9b0f9-5b7f-4fa8-9ab7-cc809435da17", maxApplicableOrders: 3 },
    { id: "b30bc55f-9952-4bc3-82a2-2db5ad299100", maxApplicableOrders: 3 },
    { id: "4cb1a2dc-1a2e-4b18-995a-1820ae0a221c", maxApplicableOrders: 3 },
    { id: "76450c42-39ab-4880-845d-ac3c98855a37", maxApplicableOrders: 3 },
    { id: "abf7a04a-175a-4229-acb7-d76c8e1db6f8", maxApplicableOrders: 7 },
    { id: "3702787e-a3f6-44c8-ab94-bad4f9d728bc", maxApplicableOrders: 3 },
    { id: "4096c319-460d-4203-b8c3-7f8d4d9aba24", maxApplicableOrders: 3 },
    { id: "3a220ba3-d379-429f-bd99-a369772f16c7", maxApplicableOrders: 5 },
    { id: "0f0292d9-0653-45f4-92af-61890a3e4de8", maxApplicableOrders: 3 },
    { id: "eac1029b-0ea0-4db8-bfa5-213e266a5c09", maxApplicableOrders: 3 },
    { id: "18b3e333-4748-464c-9832-658b1af2ae65", maxApplicableOrders: 3 },
    { id: "cd33a43c-7b12-46fb-b3a8-03f5ec895c8d", maxApplicableOrders: 15 },
    { id: "a7330fe6-13ec-43f9-aed0-89d11a6345df", maxApplicableOrders: 5 },
    { id: "04901b97-cf1f-4992-b367-93672b4491f6", maxApplicableOrders: 3 },
    { id: "52d35679-de40-4faa-8a17-17fae0e85a88", maxApplicableOrders: 15 },
    { id: "7927ccfb-6166-4512-8952-64181f0360ea", maxApplicableOrders: 3 },
    { id: "1da80a8f-452b-46f0-b717-aed690a04ae7", maxApplicableOrders: 3 },
    { id: "0c064463-9b22-45ad-a39a-12a6a9249659", maxApplicableOrders: 3 },
    { id: "f00eff85-ee3f-4f44-b6f3-038f2a0e5ad6", maxApplicableOrders: 5 },
    { id: "b53eb3b6-e128-4a7a-a8ac-626dfa147b1b", maxApplicableOrders: 3 },
    { id: "e897ffcd-74a5-415c-ba00-eea54f322641", maxApplicableOrders: 3 },
    { id: "c1e7e775-c571-4018-926f-fe094f834f4c", maxApplicableOrders: 7 },
    { id: "d7169af7-4d7e-4598-9fee-32906be407fb", maxApplicableOrders: 5 },
    { id: "720deda7-ecd6-479c-9d56-8d2a28aa5c53", maxApplicableOrders: 3 },
    { id: "29ecfe81-6219-479b-bdde-42fe447e8bf1", maxApplicableOrders: 3 },
    { id: "b3e76b9a-9e6f-4c66-89e2-6057991b0659", maxApplicableOrders: 10 },
    { id: "2508e5de-ad8a-46a3-a470-372715e90fdb", maxApplicableOrders: 3 },
    { id: "7aa3240d-0af7-467e-b4ee-5a0e3f215f69", maxApplicableOrders: 5 },
    { id: "6f905c1f-8c55-441c-bdf2-3c2e70fc7fbb", maxApplicableOrders: 15 },
    { id: "d55df7d0-6731-4f9b-9bae-a65b9afb35a0", maxApplicableOrders: 3 },
    { id: "558e7349-de90-4b33-bb3e-8ab8bfa03da7", maxApplicableOrders: 3 },
    { id: "70ea3d0c-1dcf-4c50-8452-7bff408f1716", maxApplicableOrders: 3 },
    { id: "5c0f800d-6cf1-4007-acac-b62ab3e16f10", maxApplicableOrders: 3 },
    { id: "cca79561-4a31-425a-8374-da0200a65534", maxApplicableOrders: 3 },
    { id: "aea2a2a7-d213-4556-8888-087863258e44", maxApplicableOrders: 3 },
    { id: "73bb0cef-7c89-4af5-8add-dd3399361c37", maxApplicableOrders: 3 },
    { id: "43ed8108-670a-4d26-a4e1-4835cdcbc507", maxApplicableOrders: 5 },
    { id: "ba23e452-cdf6-46be-8ec2-9466f98251b5", maxApplicableOrders: 3 },
    { id: "d090017f-95c2-4277-973f-f9fee5f660ef", maxApplicableOrders: 15 },
    { id: "eaf57c20-fb06-47e8-b4de-57d0b2d7021f", maxApplicableOrders: 3 },
    { id: "981d4238-e0cf-4573-bec5-c0c713bbf403", maxApplicableOrders: 3 },
    { id: "34640cdb-16fb-477e-aed1-8afbf8e96b5e", maxApplicableOrders: 3 },
    { id: "56496c02-9af8-43c4-8c53-e4599fa9e6f3", maxApplicableOrders: 3 },
    { id: "ecf6394c-9257-465b-9dc8-9fd8453b0c81", maxApplicableOrders: 3 },
    { id: "5eae7dc9-6352-4223-8e2c-dde26b247022", maxApplicableOrders: 3 },
    { id: "f0e2d0be-1a8b-4dc2-b62b-a95051d25897", maxApplicableOrders: 3 },
    { id: "517623ed-02f9-4d2e-a53b-249d3c068e95", maxApplicableOrders: 3 },
    { id: "07b559b0-eef7-49ee-bebe-c28f223a624a", maxApplicableOrders: 3 },
    { id: "a9f685b5-05aa-48dd-b8b6-1ddc8e60cc8d", maxApplicableOrders: 3 },
    { id: "34117d3d-ba2b-44fc-bb73-2c55ae38e198", maxApplicableOrders: 3 },
    { id: "bbcdeea6-f057-4ec0-a62a-99426b59989f", maxApplicableOrders: 3 },
    { id: "41f6b13b-8c66-411e-aa9a-4b9699328fc5", maxApplicableOrders: 3 },
    { id: "5436b53b-159b-431a-914b-26860599368d", maxApplicableOrders: 3 },
    { id: "062ec84c-6c5d-4ed4-a4b9-ed5f532e3d9d", maxApplicableOrders: 10 },
    { id: "2fae61c8-6924-46a9-a5de-ce1873a34131", maxApplicableOrders: 5 },
    { id: "32efa440-22cb-4965-8aaf-392e31f7b78d", maxApplicableOrders: 15 },
    { id: "33136384-9f9d-44f8-8336-c54c5ace3112", maxApplicableOrders: 3 },
    { id: "00cc6c63-949b-40b8-9dca-a25d6763c5ff", maxApplicableOrders: 5 },
    { id: "ba0bd7e5-16a5-45ea-ab39-b19153cb3e72", maxApplicableOrders: 3 },
    { id: "c44ce705-ad48-4501-993b-8606b114f4fb", maxApplicableOrders: 3 },
    { id: "0ed01ba3-a31b-451b-8108-6dff3e4a801c", maxApplicableOrders: 3 },
    { id: "feb8b1eb-0def-4ad3-86bd-1367c36a3328", maxApplicableOrders: 3 },
    { id: "ff1d01f3-b29f-4330-9391-62b3f8c8f79e", maxApplicableOrders: 15 },
    { id: "3c2aad70-1fd4-47f0-b7d3-84af45e16d21", maxApplicableOrders: 3 },
    { id: "4c714491-aa31-43fb-94fd-4c1decb4342e", maxApplicableOrders: 5 },
    { id: "dd23e9d0-1672-40e0-a4a2-600c9bda4d75", maxApplicableOrders: 5 },
    { id: "a6cd9dbf-e23a-419e-8f0b-09166ceee133", maxApplicableOrders: 3 },
    { id: "1d5c59a4-e730-4823-b4f4-b278933f1ffc", maxApplicableOrders: 3 },
    { id: "42a987be-8a07-45a8-b599-718ab0d74545", maxApplicableOrders: 3 },
    { id: "c6988b62-9d88-47f6-aff2-f202d0bcb3b1", maxApplicableOrders: 3 },
    { id: "b78ae316-28e2-486b-ad39-c7bdcb79bb9b", maxApplicableOrders: 5 },
    { id: "07699ed7-0ad4-488c-8363-1508d9698d44", maxApplicableOrders: 3 },
    { id: "39edf906-83d5-4ada-8ea4-29de3d5de380", maxApplicableOrders: 5 },
    { id: "a4904170-fe66-4227-822c-0415f964e5d2", maxApplicableOrders: 5 },
    { id: "7e462c57-b423-4dfd-bac5-fb50f904899c", maxApplicableOrders: 5 },
    { id: "b6f49643-4c52-4b0b-9c9c-41dbd49a4d2a", maxApplicableOrders: 3 },
    { id: "6b3579db-c622-464e-9a15-dd806c56e268", maxApplicableOrders: 15 },
    { id: "0d0f9c74-2d5b-40aa-bba9-349c9034f469", maxApplicableOrders: 3 },
    { id: "69ff9b77-6659-4b6e-abdc-c182cb4532b5", maxApplicableOrders: 3 },
    { id: "b3b4e90a-2642-4ee9-ad39-003f144e5294", maxApplicableOrders: 3 },
    { id: "a2621981-a8be-47d2-adbd-d7f4eee24b0a", maxApplicableOrders: 3 },
    { id: "0a4fa0a0-f654-422d-b932-06b15d9c5cd2", maxApplicableOrders: 10 },
    { id: "1e680beb-df66-4d3f-95dd-a73f9c772cf5", maxApplicableOrders: 3 },
    { id: "8234aff1-69a6-4607-855f-d3032f95c0d0", maxApplicableOrders: 10 },
    { id: "29588318-e190-41b7-8adc-73b4315f04da", maxApplicableOrders: 3 },
    { id: "9353a836-2442-4889-9b30-3dca9129e3f5", maxApplicableOrders: 3 },
    { id: "c74c809d-f0f8-4809-bab8-42151fbf0bc8", maxApplicableOrders: 5 },
    { id: "619736fa-5177-4788-8d7c-4c7edfab4360", maxApplicableOrders: 7 },
    { id: "d4c3ff70-f12e-46a7-8cd9-94c08f19311c", maxApplicableOrders: 7 },
    { id: "00d0ad90-9d0f-462f-b178-ae097ebc6b5c", maxApplicableOrders: 15 },
    { id: "00039b40-abca-4b01-84d1-edcf54530784", maxApplicableOrders: 5 },
    { id: "e8eee66b-3302-414a-ab9d-b70bc7c49963", maxApplicableOrders: 10 },
    { id: "87c49f57-2b00-4f36-8a90-5dd93a27e959", maxApplicableOrders: 3 },
    { id: "15e41ad9-63d9-4bed-9736-febb4e2d6cba", maxApplicableOrders: 5 },
    { id: "47b420bb-b258-4af2-b63e-9fad076bee6a", maxApplicableOrders: 3 },
    { id: "ef260d26-f631-4e1c-ad51-6fee6259e37d", maxApplicableOrders: 3 },
    { id: "a60b099c-7d5c-4454-bcd9-76577e90413d", maxApplicableOrders: 3 },
    { id: "4a42ddb4-f509-460b-ba7a-e7416853da0a", maxApplicableOrders: 3 },
    { id: "6792a6f9-46c5-42ee-8ca7-a83e9f1323df", maxApplicableOrders: 3 },
    { id: "235665ca-578f-4173-95d4-111bd3b3ddbe", maxApplicableOrders: 3 },
    { id: "4889f5d0-229b-4063-a28c-3a54db06ba82", maxApplicableOrders: 3 },
    { id: "84e72665-c441-4270-831d-af67bd1ffe1b", maxApplicableOrders: 3 },
    { id: "89ea809d-c916-4b7b-9a6e-3a7b6f2b3f4a", maxApplicableOrders: 15 },
    { id: "b64b2bcd-b629-4439-bc31-e07dfc65e30c", maxApplicableOrders: 3 },
    { id: "9a86fb3d-1dbb-478c-a6a8-31df78f45c4b", maxApplicableOrders: 3 },
    { id: "a902b97b-2791-40c2-bceb-b58afdf4bc28", maxApplicableOrders: 3 },
    { id: "f565d0d3-4aeb-44af-ad00-300ae9fb8249", maxApplicableOrders: 3 },
    { id: "b5547e13-a416-45e3-a96d-35ff9e840288", maxApplicableOrders: 3 },
    { id: "e3ec20a6-b7ed-4a29-abdd-17ddbc26287b", maxApplicableOrders: 10 },
    { id: "83800cf9-2b3f-4fd8-8edb-5dd6764b000c", maxApplicableOrders: 3 },
    { id: "ea43e9b5-2854-442a-96a8-9ffcadcebab9", maxApplicableOrders: 5 },
    { id: "25a9a1a1-8836-4e39-bba2-5fab3277526b", maxApplicableOrders: 3 },
    { id: "2c1acd67-0091-4c2f-b267-7f06575be070", maxApplicableOrders: 3 },
    { id: "0fd8532c-385c-4b10-867c-6af321f211dc", maxApplicableOrders: 5 },
    { id: "ff9638f0-abe8-4121-bc6a-e258b774e798", maxApplicableOrders: 15 },
    { id: "3983fa1a-6d5a-4549-815b-916865552534", maxApplicableOrders: 3 },
    { id: "1fcec151-35fb-4904-a83a-c726fc92b6b6", maxApplicableOrders: 5 },
    { id: "f73dca72-820f-4622-bfd6-72db0c049a80", maxApplicableOrders: 3 },
    { id: "e83430d3-2dda-4807-b245-915f8550d538", maxApplicableOrders: 3 },
    { id: "2f506e1a-5f92-47bf-92ad-d7a126af1df0", maxApplicableOrders: 3 },
    { id: "88b2db49-5fa5-4882-ba86-0dc35a3e5046", maxApplicableOrders: 3 },
    { id: "f1670fe5-9b02-4f20-b69a-a29f383734ef", maxApplicableOrders: 3 },
    { id: "b8c7ccff-3cdf-4244-b333-20f944b60bcc", maxApplicableOrders: 5 },
    { id: "eede61c0-9e5a-4e2f-a652-debb1e2c9b75", maxApplicableOrders: 3 },
    { id: "ebfd5420-c6ab-4d88-8624-a9fa4221b949", maxApplicableOrders: 3 },
    { id: "8e543ca7-3346-44c3-a1c7-3dda36664971", maxApplicableOrders: 5 },
    { id: "875d483e-358f-44bf-8a8f-1631ce8db4c5", maxApplicableOrders: 3 },
    { id: "ac05c164-b440-47c0-8082-2eed9e691899", maxApplicableOrders: 5 },
    { id: "bbdd6312-41f4-4eaa-8420-8c9a492fceb9", maxApplicableOrders: 3 },
    { id: "b263c9f6-d2c8-4ca1-aa1d-8ce9bd8dca3c", maxApplicableOrders: 3 },
    { id: "c645c65b-f69c-43aa-8a0c-474bd61762b1", maxApplicableOrders: 3 },
    { id: "b93047a0-228b-4bc8-9e47-ca5c52032600", maxApplicableOrders: 3 },
    { id: "ce54a4db-759a-4ed7-b656-90f95c753507", maxApplicableOrders: 3 },
    { id: "b2172a48-6431-48bb-a39d-8681e90cf9e8", maxApplicableOrders: 3 },
    { id: "afdfd226-2249-4a73-93bb-146a8451d7c3", maxApplicableOrders: 5 },
    { id: "a16c1718-59ec-423e-9000-e2b178f1acb2", maxApplicableOrders: 3 },
    { id: "a7582141-bb4e-48ff-bb17-616d12b62a1c", maxApplicableOrders: 10 },
    { id: "54c9fc94-e322-45b0-80a2-57b0052aa474", maxApplicableOrders: 3 }
  ]
};

const DISCOUNT_PERCENTAGE = 10;

//Returns professional or undefined
const findProfessionalOnList = id =>
  PROFESSIONALS_WHO_ACCEPT_DISCOUNT[process.env.NODE_ENV].find(
    el => el.id === id
  );

const hasOrdersToApply = id => {
  let professional = findProfessionalOnList(id);
  if (!professional) return;

  let orders = newOrderStore.state.orders_with_discount.find(
    el => el.id === professional.id
  );
  return !orders || orders.ordersCount < professional.maxApplicableOrders;
};

const canApplyDiscount = id =>
  findProfessionalOnList(id) && hasOrdersToApply(id);
const applyDiscount = price => price - (DISCOUNT_PERCENTAGE / 100) * price;

const getProfessionalsWhoAcceptDiscount = () =>
  PROFESSIONALS_WHO_ACCEPT_DISCOUNT[process.env.NODE_ENV];

const getCouponID = () => COUPON_ID[process.env.NODE_ENV];
const getDiscountPercentage = () => DISCOUNT_PERCENTAGE;

export default {
  canApplyDiscount,
  applyDiscount,
  getProfessionalsWhoAcceptDiscount,
  getCouponID,
  getDiscountPercentage,
  findProfessionalOnList
};



// WEBPACK FOOTER //
// ./src/utils/helpers/newOrder.js